import { type ReactElement, type ReactNode } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface GuideSection {
  heading: string
  body: string
  image?: string
  graphic?: ReactNode
}

interface Props {
  open: boolean
  onClose: () => void
  title: string
  sections: GuideSection[]
}

// オンボーディング（初回自動表示）とヘルプモーダル（？ボタンからの再表示）で共用するガイド表示。
export function ScreenGuideDialog ({ open, onClose, title, sections }: Props): ReactElement {
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onClose() }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className='px-6 pb-4 space-y-4 max-h-[60vh] overflow-y-auto'>
          {sections.map((section) => (
            <div key={section.heading}>
              <div className='text-[13px] font-semibold text-(--bp-ink) mb-1'>{section.heading}</div>
              {section.graphic != null && (
                <div className='w-full rounded-md border border-(--bp-border) bg-(--bp-surface2) p-4 mb-2'>
                  {section.graphic}
                </div>
              )}
              {(section.graphic == null && section.image != null && section.image !== '') && (
                <img
                  src={section.image}
                  alt={section.heading}
                  className='w-full rounded-md border border-(--bp-border) mb-2'
                />
              )}
              <div className='text-[13px] text-(--bp-ink2) leading-relaxed whitespace-pre-line'>{section.body}</div>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button onClick={onClose}>閉じる</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
